/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_PAYROLL_LIST (state, val) {
      state.payrollList = val
    },
    UPDATE_PAYROLL_LIST (state, val) {
      state.payrollList.push(...val)
    },
    UPDATE_PAYROLL (state, payroll) {
      const i = state.payrollList.findIndex(i => i.id == payroll.id)
      Object.assign(state.payrollList[i], payroll)
    },
  }
  